import { Stack } from '@mui/material'
import { clone, pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseIntroductionData } from './ConfigData'

type Introduction = {
  introduction: string
  IntroText: {
    en: string[]
  }
}
interface IntroductionEnhanced extends CustomComponentEnhanced<Introduction> {}

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch =
    useUpdateCustomComponent<Introduction>(componentID)
  const currentSemanticSearch = useGetCustomComponent<Introduction>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseIntroductionData
  )
  const parseData = (data?: IntroductionEnhanced | null) => {
    if (!data) return {}
    const introductionData = clone(data)
    if (
      introductionData.settings?.IntroText?.en?.length &&
      introductionData.settings.IntroText.en.length >= 1
    ) {
      introductionData.settings.IntroText = {
        en: introductionData.settings.IntroText.en[0].split('\n'),
      }
    }

    return pick(['name', 'description', 'settings', 'type'], introductionData)
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    await updateSemanticSearch.mutateAsync({
      ...parseData(data as unknown as CustomComponentEnhanced<Introduction>),
    } as IntroductionEnhanced)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
